<template>
	<div class="item logo" v-if="activeMerchant">
		<div class="merchant">
			<div class="ui logo image" v-if="activeMerchant.logo">
				<img :src="activeMerchant.logo" alt="logo">
			</div>
      <div class="ui small logo image" v-else>
        <img :src="defaultAvatar" alt="logo">
      </div>
			<div class="zw header">
				{{ activeMerchant.name }}
			</div>
		</div>
		<div class="zw merchant info">
			<div class="info-piece trigger">{{ $t('sidebar.merchant.phone') }}: <strong>{{ activeMerchant.phone }}</strong></div>
			<div class="info-piece" v-show="showPiece"><a target="_blank" :href="`http://maps.google.com/?q=${merchantAddress}`">{{ merchantAddress }}</a></div>
			<div class="info-piece" v-show="showPiece">{{ $t('sidebar.merchant.vat') }}: {{ activeMerchant.vat }}</div>
			<div class="info-piece" style="word-break: break-all; text-transform: none;" v-show="showPiece">{{ $t('sidebar.merchant.email') }}: <a :href="`mailto:${activeMerchant.email}`">{{ activeMerchant.email }}</a></div>
			<div class="info-piece" v-show="showPiece"><a @click.prevent="showTermsModal = true">Handelsbetingelser</a></div>
      <div class="ui bottom attached icon button" @click="toggleShowPiece()"><i class="angle double icon" :class="{ 'up' : showPiece, 'down' : !showPiece}"/></div>
		</div>

    <semantic-modal ref="payment_terms" v-model="showTermsModal" :settings="{content_classes: {content: true}, closeable: false, closeable_button: false}">
      <payment-terms/>
      <div class="actions" slot="actions">
        <div class="ui red button" @click="closeTermsModal()">Close</div>
      </div>
    </semantic-modal>

	</div>
</template>

<script>
  import defaultAvatar from '../../assets/images/default-logo.png'

	export default {
		name: 'MerchantProfile',

		data () {
			return {
        defaultAvatar,
				showPiece: false,
        showTermsModal: false
			}
		},

		methods: {
			toggleShowPiece () {
				this.showPiece = !this.showPiece
			},
      closeTermsModal () {
        this.$refs.payment_terms.hide()
      }
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			},

			merchantAddress () {
				return this.activeMerchant.address + ', ' + this.activeMerchant.zip + ' ' + this.activeMerchant.city
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/layout/MerchantProfile.vue